import { Loc, t } from "@/locales";
import { useTwoDRendererComponent } from "@/configurator/presentation/renderers/useTwoDRendererComponent";

// Placeholder for future 2D rendering (canvas, SVG, PixiJS, Konva, etc).
export function TwoDRenderer() {
  const { primaryColor } = useTwoDRendererComponent();

  return (
    <div className="two-d-renderer flex h-full w-full items-center justify-center rounded-xl bg-slate-50">
      <div className="two-d-renderer__content text-center">
        <div
          className="two-d-renderer__swatch mx-auto mb-3 h-16 w-16 rounded-xl border border-slate-200"
          style={{ backgroundColor: primaryColor }}
        />
        <div className="two-d-renderer__title text-sm font-medium text-slate-700">
          {t(Loc.twoDPlaceholderTitle)}
        </div>
        <div className="two-d-renderer__subtitle text-xs text-slate-500">
          {t(Loc.twoDPlaceholderHint)}
        </div>
      </div>
    </div>
  );
}
